var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 25.921 32.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-48.67 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.67 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.285,3.252,62.867.179a4.362,4.362,0,0,0-2.473,0L49.976,3.252A1.832,1.832,0,0,0,48.67,5v8.628A19.7,19.7,0,0,0,60.942,31.871a1.817,1.817,0,0,0,1.377,0A19.7,19.7,0,0,0,74.591,13.626V5A1.831,1.831,0,0,0,73.285,3.252Zm-.151,10.375a18.238,18.238,0,0,1-11.364,16.9.368.368,0,0,1-.279,0,18.238,18.238,0,0,1-11.364-16.9V5a.366.366,0,0,1,.261-.349L60.806,1.577a2.908,2.908,0,0,1,1.649,0L72.873,4.649A.366.366,0,0,1,73.134,5Z",
    transform: "translate(-48.67 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.774 4.139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M131.245,68.544l-7.764-2.29a1.09,1.09,0,0,0-.618,0l-7.764,2.29a1.1,1.1,0,0,0-.784,1.048v6.1a15.484,15.484,0,0,0,2.821,8.947,15.686,15.686,0,0,0,5.53,4.865,1.091,1.091,0,0,0,1.012,0,15.687,15.687,0,0,0,5.53-4.865,15.484,15.484,0,0,0,2.821-8.947v-6.1A1.1,1.1,0,0,0,131.245,68.544Zm-.673,7.152a14.034,14.034,0,0,1-2.557,8.109,14.233,14.233,0,0,1-4.843,4.321,14.233,14.233,0,0,1-4.843-4.321,14.034,14.034,0,0,1-2.557-8.109V69.865l7.4-2.182,7.4,2.182Z",
    transform: "translate(-114.314 -66.21)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shieldIcon.dc486b8297707ab27b4a407c7732fae1.svg";
export { ForwardRef as ReactComponent };